import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppService } from '../../../app.service';
import { Observable, of } from 'rxjs';

export interface IpDto {
    name: string;
    ip_id: string;
    ip_addr: string;
    mac_addr: string;
    subnet_name: string;
    subnet_id: string;
    hostaddr: string;
    vlan: string;
    subnetMask: string;
    gatewayAddress: string;
    deleting?: boolean;
    editing?: boolean;
}

export interface ServiceIpInfoResponse {
    ipList: IpDto[];
    vlan605Enabled: boolean;
}

export interface AddIpRestDto {
    serviceId: string;
    ipAddress: string;
    vlan: string;
    mac: string;
}

export interface ModifyIpRestDto {
    serviceId: string;
    ipId: string;
    ipAddress: string;
    mac: string;
}

export interface DeleteIpRestDto {
    serviceId: string;
    ipId: string;
    ipAddress: string;
}

export interface reprovisionWithCgnatAndVlan631 {
    iua: string;
    vlan631: boolean;
    cgnat: boolean;
    pfiRequired: boolean;
    acsRequired: boolean;
    msmRequired: boolean;
}


export interface ReprovisionDto {
    iua: string;
    pfiRequired: boolean;
    acsRequired: boolean;
    msmRequired: boolean;
}


@Injectable({
    providedIn: 'root'
})
export class IpService {

    appData: any;

    constructor(
        private httpClient: HttpClient,
        private appService: AppService,
    ) {
        this.appData = appService.settings;
    }

    getIpList(remoteId: string): Observable<ServiceIpInfoResponse> {
        return this.httpClient.get<ServiceIpInfoResponse>(`${this.appData.webApi}/ip/v1/${remoteId}`);
    }

    addIp(body: AddIpRestDto): Observable<any> {
        return this.httpClient.post<any>(`${this.appData.webApi}/ip/v1`, body);
    }

    modifyIp(body: ModifyIpRestDto): Observable<any> {
        return this.httpClient.put<any>(`${this.appData.webApi}/ip/v1`, body);
    }

    deleteIp(body: DeleteIpRestDto): Observable<any> {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            body
        }
        return this.httpClient.delete<any>(`${this.appData.webApi}/ip/v1`, options);
    }

    enableCgnat(serviceId: string): Observable<any> {
        return this.httpClient.post<any>(`${this.appData.webApi}/ip/cgnat/${serviceId}`, {});
    }

    disableCgnat(serviceId: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.appData.webApi}/ip/cgnat/${serviceId}`);
    }

    enableVlan631(serviceId: string): Observable<any> {
        return this.httpClient.post<any>(`${this.appData.webApi}/ip/vlan631/${serviceId}`, {});
    }

    disableVlan631(serviceId: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.appData.webApi}/ip/vlan631/${serviceId}`);
    }

    reprovisionWithCgnatAndVlan631(body: reprovisionWithCgnatAndVlan631): Observable<any> {
        return this.httpClient.post<any>(`${this.appData.webApi}/ip/reprovisionWithCgnatAndVlan631`, body);
    }

    reprovision(body: ReprovisionDto): Observable<any> {
        return this.httpClient.post<any>(`${this.appData.webApi}/ftth/reprovision`, body);
    }

}
